//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import b from 'b_';
import cx from 'classnames';
import { ClockClear as IconClock, Count as IconCards } from 'education-icons';
import { Select, Text } from 'platform-components';
import { SELECT_THEMES, TEXT_MARKUP_TYPE } from 'platform-components/constants';
import { mediaQueryResolver, SCREEN_SIZE, WithMediaQueryResolverProps } from 'platform-components/hocs';
import React from 'react';

import { SCREEN_QUERY } from 'common.components/lesson-view.common/constants';
import { getIsLessonEvaluable } from 'utils/lesson';

//@ts-ignore
import BREAKPOINTS from '../../../design/breakpoints.scss';

import './assignment__lesson-mode.scss';

interface HOCProps extends WithMediaQueryResolverProps {}

interface OwnProps {
    currentMode: CLESSON_MODES;
    onSelectMode: (mode: CLESSON_MODES) => void;
    shouldShowError?: boolean;
    disabled: boolean;
}

interface Props extends OwnProps, HOCProps {}

export const LessonMode = (props: Props) => {
    const { currentMode, onSelectMode, shouldShowError, screenSize, disabled } = props;
    const options = [
        {
            type: CLESSON_MODES.LESSON,
            icon: <IconCards />,
        },
        {
            type: CLESSON_MODES.CONTROL_WORK,
            icon: <IconClock />,
        },
    ];

    const isEvaluable = getIsLessonEvaluable(currentMode);
    const isMobile = screenSize === SCREEN_SIZE.SMALL;
    const SELECT_WIDTH = isMobile ? '100%' : '232px';

    return (
        <div className="assignment__lesson-modes">
            <Select
                disabled={disabled}
                focused={false}
                minWidth={SELECT_WIDTH}
                mix="assignment__lesson-mode-select"
                onChange={(e: { target: { value: CLESSON_MODES } }) => onSelectMode(Number(e.target.value))}
                popupMix="assignment__lesson-mode-select-popup"
                theme={SELECT_THEMES.TEACHER}
                value={currentMode}
                width={isMobile ? SELECT_WIDTH : undefined}
            >
                {options.map((option) => (
                    <Select.Option
                        key={option.type}
                        mix={cx(b('assignment', 'lesson-mode-item'), `qa_lesson-mode-${option.type}`)}
                        value={option.type}
                    >
                        <div className="assignment__lesson-mode-item-wrapper">
                            <div className="assignment__lesson-mode-icon">{option.icon}</div>
                            <Text id={`assignLessonModal.lessonModes.mode.${option.type}`} />
                        </div>
                    </Select.Option>
                ))}
            </Select>
            {shouldShowError && (
                <div className="assignment__error">
                    <Text id="assignLessonModal.lessonModes.error" />
                </div>
            )}
            {currentMode && (
                <div className="assignment__lesson-mode-message">
                    <Text
                        id={
                            isEvaluable
                                ? 'assignLessonModal.lessonModes.evaluableMessage'
                                : 'assignLessonModal.lessonModes.lessonMessage'
                        }
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                    />
                </div>
            )}
        </div>
    );
};

const mode = mediaQueryResolver([], BREAKPOINTS, SCREEN_QUERY)(LessonMode) as React.ComponentType<OwnProps>;
mode.displayName = 'LessonMode';

export default mode;
